module.exports = __webpack_public_path__ + "static/media/headphones.20c2dbd4.png";